import { useState, useEffect } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL, HEADERS } from "../../../utils/constant";

const ExpenseStatusModal = ({
  show,
  handleClose,
  onAddExpense,
  expenseData,
}) => {
  const [status, setStatus] = useState(expenseData?.status || "Submitted");
  const [loading, setLoading] = useState(false);
  const [approvedAmount, setApprovedAmount] = useState(
    expenseData?.approvedAmount || "",
  );
  const [approvedRemark, setApprovedRemark] = useState(
    expenseData?.approvedRemark || "",
  );
  const [rejectedRemark, setRejectedRemark] = useState(
    expenseData?.rejectedRemark || "",
  );
  const [paidRemark, setPaidRemark] = useState(expenseData?.paidRemark || "");

  useEffect(() => {
    if (expenseData) {
      setStatus(expenseData.status || "Submitted");
      setApprovedAmount(expenseData.approvedAmount || "");
      setApprovedRemark(expenseData.approvedRemark || "");
      setRejectedRemark(expenseData.rejectedRemark || "");
      setPaidRemark(expenseData.paidRemark || "");
    }
  }, [expenseData]);

  const handleUpdateExpense = async () => {
    try {
      setLoading(true);

      const payload = { status };

      if (status === "Approved" && approvedAmount) {
        payload.approvedAmount = approvedAmount;
      }
      if (status === "Approved" && approvedRemark) {
        payload.approvedRemark = approvedRemark;
      }
      if (status === "Rejected" && rejectedRemark) {
        payload.rejectedRemark = rejectedRemark;
      }
      if (status === "Paid" && paidRemark) {
        payload.paidRemark = paidRemark;
      }

      await axios.put(`${BASE_URL}/api/expenses/${expenseData.id}/`, payload, {
        headers: HEADERS,
      });

      toast.success("Expense updated successfully");

      onAddExpense();

      handleClose();
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        const errorMessage = error.response.data.error;
        toast.error(errorMessage);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = (e) => {
    const selectedStatus = e.target.value;
    setStatus(selectedStatus);

    if (selectedStatus !== "Approved") setApprovedAmount("");
    if (selectedStatus !== "Approved") setApprovedRemark("");
    if (selectedStatus !== "Rejected") setRejectedRemark("");
    if (selectedStatus !== "Paid") setPaidRemark("");
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Update Expense Status</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Status</Form.Label>
            <Form.Control
              as="select"
              value={status}
              onChange={handleStatusChange}
            >
              <option value="Submitted">Submitted</option>
              <option value="Approved">Approved</option>
              <option value="Rejected">Rejected</option>
              <option value="Paid">Paid</option>
            </Form.Control>
          </Form.Group>

          {status === "Approved" && (
            <Form.Group className="mb-3">
              <Form.Label>Approved Amount</Form.Label>
              <Form.Control
                type="number"
                value={approvedAmount}
                onChange={(e) => setApprovedAmount(e.target.value)}
              />
            </Form.Group>
          )}

          {(status === "Approved" ||
            status === "Rejected" ||
            status === "Paid") && (
            <Form.Group className="mb-3">
              <Form.Label>Remark</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={
                  status === "Approved"
                    ? approvedRemark
                    : status === "Rejected"
                      ? rejectedRemark
                      : status === "Paid"
                        ? paidRemark
                        : ""
                }
                onChange={(e) => {
                  if (status === "Approved") setApprovedRemark(e.target.value);
                  if (status === "Rejected") setRejectedRemark(e.target.value);
                  if (status === "Paid") setPaidRemark(e.target.value);
                }}
              />
            </Form.Group>
          )}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button
          variant="primary"
          id="submit"
          disabled={loading}
          onClick={handleUpdateExpense}
        >
          {loading ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />{" "}
            </>
          ) : (
            "Submit"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ExpenseStatusModal;
